<div *ngIf="airports?.length > 0" class="_space-y-2">
    <div *ngFor="let airport of airports" class="_flex _justify-between _items-center">
        <div class="text-medium text-gray-900">
            {{ airport.name }}
        </div>
        <div class="text-medium font-semibold text-gray-700 text-right">
            {{ airport.distance / 1000 | number:'1.0-0' }} km
        </div>
    </div>
</div>

<div *ngIf="!airports?.length">
    <p class="text-medium text-gray-500">No airports found</p>
</div>
